import GeoCalculationItem from "../../dto/GeoCalculationItem";
import Item from "../../../layers/dto/Item";
import { createGeoCalculationCollection } from "../../util/FeatureCollection";
import { updateObject } from "../../../common/util/UpdateObject";
import { AnyAction, IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { GeoCalcState } from "../../types";
import Logger from "../../../common/util/Logger";

const logger = new Logger();

export const loadVisualisedGeoCalculationReducer: IPartialReducer<GeoCalcState> = (state, action: AnyAction) => {
    const treeItemsVisualisedBefore = state.items && state.items[0] ? state.items[0].children : [];

    action.geoCalculations.forEach((geoCalculation: GeoCalculationItem) => (geoCalculation.visibility = true));
    const addedGeoCalcItemIds = treeItemsVisualisedBefore.map((item: GeoCalculationItem) => item.id);
    const filteredGeoCalcItems = action.geoCalculations.filter(
        (value: GeoCalculationItem) => !addedGeoCalcItemIds.includes(value.id)
    );
    const treeItems = [...treeItemsVisualisedBefore, ...filteredGeoCalcItems];

    const rootItem = new GeoCalculationItem(
        new Item(
            "geoCalculationRoot",
            "Geo Calculations",
            action.geoCalculations && action.geoCalculations.length > 0,
            true,
            true,
            false,
            treeItems
        )
    );

    const geoCalculations = [rootItem];

    logger.info(
        `loading geoCalculation '${action.geoCalculations.map(
            (calculation: GeoCalculationItem) => calculation.id
        )} geometry`
    );
    const previousFeatures = state.featureLayer ? state.featureLayer.features[0].features : [];
    const previousTextFeatures = state.textLayer ? state.textLayer.features[0].features : [];

    const allFeatures = createGeoCalculationCollection(
        previousFeatures,
        action.geoCalculations,
        action.style.feature,
        "feature"
    );
    const allLabels = createGeoCalculationCollection(
        previousTextFeatures,
        action.geoCalculations,
        action.style.label,
        "text"
    );

    return updateObject(state, {
        items: geoCalculations,
        featureLayer: allFeatures,
        textLayer: allLabels,
    });
};
